import { OnFileEventFn, OnFileFn } from "../FileProcessor";

export async function processCsv(
  data: string,
  type: "csv" | "tsv",
  onFile: OnFileFn,
  onFileEvent: OnFileEventFn,
  onChooseColumns: (columns: string[]) => Promise<number[]>,
): Promise<any> {
  console.log('NOTE the .csv/.tsv importer uses column (1) for ID, column (2) for question, column (3) for answer.')

  const lines = data.split("\n");
  const header = lines[0].split(type === "csv" ? "," : "\t");
  // const columns = await onChooseColumns(header);
  const rows = lines.slice(1).map((line) =>
    line.split(type === "csv" ? "," : "\t")
  );

  let hasIDs = header.length >= 3;

  console.log('Got header', header)
  console.log('Got rows', rows)

  console.log(`Using columns: ID=${hasIDs ? header[0] : 'none (will generate IDs)'}, Question=${hasIDs ? header[1] : header[0]}, Answer=${hasIDs ? header[2] : header[1]}`)

  const map = {};
  const generateRandomId = () => {
    return Math.random().toString(36).substring(2, 15);
  };
  rows.forEach((row, index) => {
    const id = hasIDs ? row[0] : generateRandomId();
    // Strip quotes
    let q = hasIDs ? row[1] : row[0];
    let a = hasIDs ? row[2] : row[1];
    if (!q || !a) {
      console.warn(`Skipping row ${index} because it's missing a question or answer: ${JSON.stringify(row)}`)
      return;
    }
    q = q.replace(/^"(.*)"$/, '$1');
    a = a.replace(/^"(.*)"$/, '$1');
    map[id] = {
      id,
      q,
      a,
    }
  });

  // pick random 100 rows
  // const randomRows = Object.keys(map).sort(() => 0.5 - Math.random()).slice(
  //   0,
  //   100,
  // );
  // const randomMap = {};
  // randomRows.forEach((row) => {
  //   randomMap[row] = map[row];
  // });

  const syntheticPack = {
    "metadata": {
      id: "my-csv-import",
      name: "Imported CSV",
      version: "0.0.1",
      contentType: "application/json",
      tags: [],
    },
    "data": {
      wiring: ["Front>Back"],
      reps: {
        Front: {
          promptText: "Question",
        },
        Back: {
          promptText: "Answer",
        },
      },
      concepts: Object.keys(map).map((key, index) => ({
        id: map[key].id,
        reps: {
          Front: {
            text: map[key].q,
          },
          Back: {
            text: map[key].a,
          },
        },
      })),
      // fields: intermediateApkgFormat.fields,
      templates: {},
    },
    extra: {},
  }

  onFile(
    syntheticPack,
    "pack.csv",
    "application/json",
  );
  onFileEvent({ type: "import_end", filetype: "apkg" });
}
